import { BaseFilterComponent } from './types';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { defineMessages, useIntl } from 'react-intl';
import { ExpressedGenesFilterOption } from '../options/types';
import { Filter } from '../../types';
import { FormBox } from '@lifeomic/chroma-react/components/FormBox';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import * as React from 'react';

const messages = defineMessages({
  top: {
    id: 'omicsExplorer.filterResultsManager.components.expressedGenes.top',
    defaultMessage: 'Order by Highest Expressed',
  },
  bottom: {
    id: 'omicsExplorer.filterResultsManager.components.expressedGenes.bottom',
    defaultMessage: 'Order by Lowest Expressed',
  },
  addFilter: {
    id: 'omicsExplorer.filterResultsManager.components.expressedGenes.addFilter',
    defaultMessage: 'Add Filter',
  },
  selectAnExpressionRank: {
    id: 'omicsExplorer.filterResultsManager.components.expressedGenes.selectAnExpressionRank',
    defaultMessage: 'Select an expression rank',
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  spacing: {
    marginBottom: theme.spacing(2),
  },
  itemsInput: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
  },
}));

export type ExpressedGenesClasses = GetClasses<typeof useStyles>;

interface ExpressedGenesProps
  extends ExpressedGenesFilterOption,
    BaseFilterComponent {}

export const ExpressedGenes: React.FC<ExpressedGenesProps> = ({
  injectedProps: { expressedGenesOption, searchKey },
  onFilterAdd,
  origin,
}) => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();
  const [{ topBottom }, setExpressedGenes] = React.useState({
    topBottom: 'top',
  });

  const handleSelectChange = (value: string) => {
    setExpressedGenes({
      topBottom: value,
    });
  };

  const handleSubmitClick = () => {
    if (onFilterAdd) {
      const option: Filter = {
        id: expressedGenesOption.id,
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        origin,
        searchKey,
        // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
        friendlyName: formatMessage(expressedGenesOption[topBottom]),
        searchValue: topBottom === 'top' ? 'expression:desc' : 'expression',
      };

      onFilterAdd(option);
    }
  };

  return (
    <FormBox className={classes.root}>
      <Select
        aria-label={formatMessage(messages.selectAnExpressionRank)}
        label=""
        popoverAriaLabel={formatMessage(messages.selectAnExpressionRank)}
        value={topBottom}
        onChange={handleSelectChange}
        fullWidth
      >
        <SelectOption
          key="top"
          value="top"
          title={formatMessage(messages.top)}
        />
        <SelectOption
          key="bottom"
          value="bottom"
          title={formatMessage(messages.bottom)}
        />
      </Select>
      <Button variant="contained" onClick={handleSubmitClick} fullWidth>
        {formatMessage(messages.addFilter)}
      </Button>
    </FormBox>
  );
};
